export const DashboardIcon = (props: any) => {
  return (
    <svg
      className={props.className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.02308 14.4814V10.9509H8.97692V14.4814C8.97692 14.6467 9.04514 14.8044 9.16526 14.9201C9.28526 15.0357 9.44724 15.1 9.61539 15.1H14.4615C14.6297 15.1 14.7917 15.0357 14.9117 14.9201C15.0318 14.8044 15.1 14.6467 15.1 14.4814L15.1 5.14595L15.1 5.14532C15.0993 5.03663 15.0691 4.93023 15.0127 4.83673C14.9563 4.74334 14.8758 4.66623 14.7796 4.61267C14.7795 4.61262 14.7795 4.61258 14.7794 4.61253L8.31821 0.982302L8.31821 0.982301L8.31783 0.982088C8.22097 0.928223 8.11137 0.9 8 0.9C7.88864 0.9 7.77903 0.928223 7.68217 0.982088L7.68217 0.982087L7.68179 0.982302L1.22063 4.61253C1.22057 4.61256 1.22052 4.61259 1.22046 4.61262C1.12421 4.66618 1.04372 4.74331 0.987336 4.83673C0.930897 4.93023 0.900683 5.03663 0.900002 5.14532H0.9V5.14595V14.4814C0.9 14.6467 0.968214 14.8044 1.08834 14.9201C1.20834 15.0357 1.37032 15.1 1.53846 15.1H6.38462C6.55276 15.1 6.71474 15.0357 6.83474 14.9201C6.95486 14.8044 7.02308 14.6467 7.02308 14.4814ZM13.8231 13.8627H10.2538V10.3323C10.2538 10.167 10.1856 10.0092 10.0655 9.89354C9.94551 9.77796 9.78353 9.71366 9.61539 9.71366H6.38462C6.21647 9.71366 6.05449 9.77796 5.93449 9.89354C5.81437 10.0092 5.74615 10.167 5.74615 10.3323V13.8627H2.17692V5.50012L8 2.2318L13.8231 5.50012V13.8627Z"
        fill="#4187F5"
        stroke="#4187F5"
        strokeWidth="0.2"
      />
    </svg>
  );
};
